import type { Card } from '../../types';

/** Epic support — stacks Poison and Weaken in one play (§3). */
export const PANDEMIC: Card = {
  id: 'pandemic',
  name: 'Pandemic',
  type: 'support',
  rarity: 'epic',
  size: { w: 2, h: 2 },
  cost: [
    { kind: 'min', value: 4 },
    { kind: 'min', value: 4 },
  ],
  effects: [
    {
      kind: 'applyStatus',
      application: { status: 'poison', magnitude: 5, duration: 3, target: 'opponent' },
    },
    {
      kind: 'applyStatus',
      application: { status: 'weaken', magnitude: 3, duration: 2, target: 'opponent' },
    },
  ],
};
